module.exports = __webpack_public_path__ + "media/images/static/top/urban/right_photo-7fd8a0a0590b4fdb905648c6ffe876fd.png";